<template>
    <div class="update-shared-event" v-if="getUpdateSharedEvent != null">
        <div class="update-shared-event__header">
            Update Share Event

            <div class="close" @click="clearUpdateSharedEvent">
                <i class="material-icons" style="color: white;">close</i>
            </div>
        </div>
        <div class="update-shared-event__input-wrapper">
            <div>
                <span class="label">Name</span>
            </div>
            <v-text-field
                label="Name"
                placeholder="Name"
                class="small-field"
                v-model="shareEventForm.name"
                outline
                single-line
                hide-details
            ></v-text-field>
        </div>
        <div class="update-shared-event__input-wrapper">
            <div>
                <span class="label">Description</span>
            </div>
            <v-text-field
                label="Description"
                placeholder="Description"
                class="small-field"
                v-model="shareEventForm.description"
                outline
                single-line
                hide-details
            ></v-text-field>
        </div>
        <div class="update-shared-event__input-wrapper">
            <div>
                <span class="label">Expiration date</span>
            </div>
            <date-picker
                v-model="shareEventForm.expirationDate"
                placeholder="Pick date"
                :clearable="false"
                :default-value="new Date()"
                :disabled-date="disabledBeforeToday"
                type="date"
            ></date-picker>
        </div>
        <div class="update-shared-event__input-wrapper update-shared-event__button">
            <sp-button sp-class="no-padding-right" icon="share-square-solid" text="Update" @click.native="updateSharedEvent"></sp-button>
        </div>

        <sp-loader v-show="isProcessing"></sp-loader>

    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import { DeviceEventSharedApi } from '@/api'
import SpLoader from '@/components/atoms/Loader'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { DeviceEventShareTransformer } from '@/transformers'
import toast from '@/plugins/izitoast'
import DatePicker from 'vue2-datepicker'

const deviceEventSharedApi = new DeviceEventSharedApi()
const deviceEventShareTransformer = new DeviceEventShareTransformer()

export default {
    name: 'UpdateSharedEvent',
    components: {
        SpButton,
        SpLoader,
        DatePicker
    },
    mounted () {
        this.minDate = moment().format('YYYY-MM-DD')
    },
    data () {
        return {
            minDate: '',
            isShareEventExpirationPickerShow: false,
            isProcessing: false,
            shareEventForm: {
                expirationDate: moment()._d,
                name: '',
                description: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            getUpdateSharedEvent: 'trackingModule/getUpdateSharedEvent'
        })
    },
    watch: {
        getUpdateSharedEvent: {
            async handler (value) {
                if (null == value) {
                    return
                }

                const result = await deviceEventSharedApi.getDeviceEventSharedById(value)

                const sharedEvent = result.payload

                this.shareEventForm.name = sharedEvent.name
                this.shareEventForm.description = sharedEvent.description
                this.shareEventForm.expirationDate = moment(sharedEvent.expirationDate)._d
            }
        }
    },
    methods: {
        ...mapActions({
            setUpdateSharedEvent: 'trackingModule/setUpdateSharedEvent'
        }),
        clearUpdateSharedEvent () {
            this.setUpdateSharedEvent(null)
        },
        async updateSharedEvent () {
            this.isProcessing = true

            try {
                await deviceEventSharedApi.updateDeviceEventShare({
                    id: this.getUpdateSharedEvent,
                    name: this.shareEventForm.name,
                    description: this.shareEventForm.description,
                    expirationDate: this.shareEventForm.expirationDate
                })
            } catch (e) {
                this.isProcessing = false
                toast.error('Cannot update this shared event.')
            }

            this.isProcessing = false
            toast.success('Event shared updated successfully.')

            this.shareEventForm = {
                expirationDate: null,
                name: '',
                description: ''
            }

            this.setUpdateSharedEvent(null)
        },
        disabledBeforeToday (date) {
            const today = new Date()

            return date < today
        }
    }
}
</script>

<style scoped lang="scss">
.update-shared-event {
    &__header {
        background: #1d2a39;
        color: $white;
        font-weight: bold;
        padding: 8px 13px;
        font-size: 14px;
        border-radius: 8px;
        margin-top: 10px;
    }

    &__input-wrapper {
        margin-bottom: 15px;
    }

    &__button {
        text-align: right;
    }

    .label {
        font-size: 12px;
        font-weight: 700;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
}

.close {
    position: absolute;
    top: 7px;
    right: 9px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}

</style>
